import { DecimalPipe, TitleCasePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { Surcharge } from 'app/model/booking/my-booking-model';
import { TranslatePipe } from 'app/pipes/translate.pipe';

@Injectable()
export class ThankyouService {

  constructor(
    private titlecasePipe: TitleCasePipe,
    private decimalPipe: DecimalPipe,
    private translatePipe: TranslatePipe
  ) { }

  transfromSurcharge(surcharges: Surcharge[], type: string): string {
    const listSurcharges = [];
    surcharges && surcharges.map((sur) => {
      if (sur.charge === type) {
        listSurcharges.push(`${sur.name.toString()} THB ${this.decimalPipe.transform(sur.price, '1.2-2')}`);
      }
    });
    listSurcharges.length > 0 && listSurcharges.join(', ');
    return listSurcharges.length > 0 ?
      this.translatePipe.transform(type === 'include' ? 'cart-surcharge-include' : 'thankyou-surcharge-exclude').replace('{text}', listSurcharges) :
      undefined;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/thankyou/thankyou.service.ts